import { getUID } from '@redviking/argonaut-util/src/getUID';
import { getAppletEvents } from '@redviking/argonaut-util/src/mes/get-applet-events';
import type { UiNodeSpec } from './UiNodeSpec';

export const appletEventEmitUiNodeSpec: UiNodeSpec<'appletEventEmit'> = {
    requiredSockets: [ 'trigger' ],
    cfg: () => ({ controlValues: { appletEventId: '' }, id: getUID(), kind: 'appletEventEmit', disabled: false }),
    controls: getNodeCfg => ({
        appletEventId: {
            cfg: {
                kind: 'selectEvent',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.appletEventId,
        },
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
    }),
    kindLabel: 'Emit Applet Event',
    nodeCategory: 'events',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: (node, appletDesignVersionConfig) => {
        const events = getAppletEvents(appletDesignVersionConfig);
        const validEventNames = Object.keys(events);
        const errors: Record<string, string> = {};
        if (!node.controlValues.appletEventId) {
            errors.appletEventId = 'Event ID is required';
        }
        if (!validEventNames.includes(node.controlValues.appletEventId)) {
            errors.appletEventId = 'Event ID is not a valid event';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
